import {
    IonButton,
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import SelectState from "./SelectState";
import Spinner from "../Spinners/Spinner";
import ErrorAlert from "../Errors/ErrorAlert";

interface _Props {
    locationString?: (string | null)
    onSubmit: (updatedLocationString: string) => void
}

const LocationForm: React.FC<_Props> = ({locationString, onSubmit}) => {

    const [isMounted, setIsMounted] = useState(true);
    const [isDisabled, setIsDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [city, setCity] = useState<string>("");
    const [provState, setProvState] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        const getDataFromLocationString = (location: string) => {
            const addressArray = location.split(",");
            setCity((addressArray.length > 1) ? addressArray[0] : "");
            setProvState((addressArray.length > 1) ? addressArray[1] : (addressArray[0] || ""));
        }
        if (locationString) getDataFromLocationString(locationString)
    }, [locationString]);

    const verifyForm = () => {
        if (!city || city === "") {
            setError("Please include the city.");
            return false;
        }
        if (!provState || provState === "-") {
            setError("Please include the state or province.");
            return false;
        }
        return true;
    }

    const handleProvStateInputChange = (value: string) => {
        setIsDisabled(false);
        setProvState(value);
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        setError("");
        const isValid = verifyForm();
        if (isValid) {
            const updatedLocationString = city + ", " + provState;
            onSubmit(updatedLocationString);

        }
        setIsDisabled(true);
        setIsLoading(false);
    }

    return (
        <>
            {error && <ErrorAlert width="12" error={error}/>}
            <form>
                <IonRow>
                    <IonCol sizeXs="12" sizeLg="6">
                        <IonItem color="white">
                            <IonLabel position="stacked">City</IonLabel>
                            <IonInput 
                                type="text"
                                value={city}
                                aria-required={true}
                                onIonChange={e => {
                                    if(isMounted) setIsDisabled(false);
                                    else setIsMounted(true);
                                    setCity(e.detail.value!)
                                }}
                            />
                        </IonItem>
                    </IonCol>
                    <IonCol sizeXs="12" sizeLg="6">
                        <SelectState selectedValue={provState} onInputChange={handleProvStateInputChange} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol sizeMd="4">
                        {isLoading ?
                            <Spinner />
                            :
                            <IonButton
                                disabled={isDisabled}
                                className="ion-margin-top"
                                color="tertiary"
                                expand="block"
                                onClick={handleSubmit}
                            >
                                {isDisabled ? "Saved" : "Save"}
                            </IonButton>
                        }
                    </IonCol>
                </IonRow>
            </form>
        </>
    );
};

export default LocationForm;